import { useEffect, useRef, useState } from 'react';
const useIntersectionObserver = (
  intersectionIdList = [],
  options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  }
) => {
  const [intersectElemId, setIntersectElemId] = useState('');

  const callback = (entries = []) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setIntersectElemId(entry.target.id);
      }
    });
  };

  useEffect(() => {
    if (intersectionIdList.length === 0) return;

    const intersectionObserver = new IntersectionObserver(callback, options);

    intersectionIdList.forEach((sectionId) => {
      const elem = document.getElementById(sectionId);
      if (elem) {
        intersectionObserver.observe(elem);
      }
    });

    return () => {
      intersectionObserver.disconnect();
    };
  }, [intersectionIdList]);

  return intersectElemId;
};

export default useIntersectionObserver;
